// src/modules/Scheduling/shared/availability/picker-values.ts
/**
* Reading a date back out of an atalaya picker.
*
* Only dates need this. A clock time goes through the pickers as `HH:mm`
* (`valueFormat="HH:mm"`), which carries no date and no zone, but a picker in
* `mode="date"` still reports an instant — so the calendar date it was showing
* has to be read in the zone the picker was showing it in.
*
* `timeZone` is optional: without it, the value is read off the viewer's own
* local clock, which is what an app with no `TimezoneProvider` displays —
* and what profile's time-off modal relies on today.
*/
function pickerValueToDateKey(iso, timeZone) {
	if (!iso) return void 0;
	const date = new Date(iso);
	if (Number.isNaN(date.getTime())) return void 0;
	if (!timeZone) {
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const day = String(date.getDate()).padStart(2, "0");
		return `${date.getFullYear()}-${month}-${day}`;
	}
	return new Intl.DateTimeFormat("en-CA", {
		day: "2-digit",
		month: "2-digit",
		timeZone,
		year: "numeric"
	}).format(date);
}
export { pickerValueToDateKey };

//# sourceMappingURL=picker-values.js.map